export enum RowLayout {
  FULL_WIDE = 'FULL_WIDE',
  PAGE_WIDE = 'PAGE_WIDE',
  MAX_WIDTH_CENTER = 'MAX_WIDTH_CENTER',
  MAX_WIDTH_CENTER_WIDE = 'MAX_WIDTH_CENTER_WIDE',
  TWO_COLUMN_HALFS = 'TWO_COLUMN_HALFS',
  TWO_COLUMN_WIDE_LEFT = 'TWO_COLUMN_WIDE_LEFT',
  TWO_COLUMN_WIDE_RIGHT = 'TWO_COLUMN_WIDE_RIGHT',
  TWO_COLUMN_NARROW_LEFT = 'TWO_COLUMN_NARROW_LEFT',
  TWO_COLUMN_NARROW_RIGHT = 'TWO_COLUMN_NARROW_RIGHT',
  THREE_COLUMN = 'THREE_COLUMN',
  FOUR_COLUMN = 'FOUR_COLUMN',
  FIVE_COLUMN = 'FIVE_COLUMN',
  ONE_COLUMN_WITH_SIDEBAR = 'ONE_COLUMN_WITH_SIDEBAR',
  ONE_COLUMN_WITH_SIDEBAR_REVERSE = 'ONE_COLUMN_WITH_SIDEBAR_REVERSE',
  NARROW_COLUMN_CENTER = 'NARROW_COLUMN_CENTER',
}
